import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '12.1449 3.2698'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M23.8697 0.799805C23.8697 0.799805 19.7197 2.19977 12.1497 2.19977C4.57969 2.19977 0.429688 0.799805 0.429688 0.799805C4.73969 4.9598 9.39969 5.73981 12.1497 5.73981C14.8997 5.73981 19.5697 4.9698 23.8697 0.799805Z"
          fill={outline}
        />
        <path
          d="M0.419922 0.799805C1.35992 1.1998 2.29991 1.55979 3.26991 1.84979C3.74991 2.00979 4.23991 2.13979 4.71991 2.27979L6.18991 2.62976C8.15991 3.04976 10.1599 3.27979 12.1599 3.28979C14.1599 3.32979 16.1599 3.12976 18.1199 2.68976C20.0999 2.31976 21.9799 1.55975 23.8699 0.809753C23.4299 1.05975 22.9799 1.3098 22.5299 1.5498C22.0799 1.7898 21.6399 2.0498 21.1599 2.2298L19.7299 2.7998C19.2499 2.9898 18.7499 3.09976 18.2599 3.24976C17.2799 3.57976 16.2499 3.68976 15.2399 3.87976C14.2099 3.95976 13.1899 4.07979 12.1499 4.03979C10.0899 4.00979 8.02991 3.74976 6.04991 3.18976C4.07991 2.63976 2.14992 1.8798 0.419922 0.799805Z"
          fill="#2A1B13"
        />
      </g>
    </g>
  )
}
